
<button class="btn btn-outline-primary"
        [disabled]="ticketId === null"
        (click)="reprint()">
  Reimprimir Ticket
</button>
